var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQr = function SvgQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qr_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.25 12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163V4.163C95.006 1.863 96.87 0 99.17 0h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 0h-12.243v12.244h12.243V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 0h-12.243v12.244h12.243V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.876 0h-12.243v12.244h12.243V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.508 12.244V0h8.081a4.162 4.162 0 0 1 4.162 4.163v8.08h-12.243ZM237.895 12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163V4.163c0-2.3 1.864-4.163 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.523 12.244V0h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM273.156 3.502v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24A3.511 3.511 0 0 0 281.898 0h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM142.876 11.877h-12.243V24.12h12.243V11.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 11.877h-12.243V24.12h12.243V11.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.626 11.877h-12.243V24.12h12.243V11.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 11.877h-12.243V24.12h12.243V11.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.376 11.877h-12.243V24.12h12.243V11.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.023 24.12V11.876h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM213.773 15.378v5.253a3.491 3.491 0 0 0 3.502 3.49h5.253a3.493 3.493 0 0 0 3.501-3.503v-5.24a3.51 3.51 0 0 0-3.514-3.502h-5.24a3.502 3.502 0 0 0-3.502 3.502ZM246.039 23.875v.245h3.734v-3.734h-.244a3.489 3.489 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.398 24.12v-8.08c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.162v8.081h-12.244ZM119.125 35.997h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918c0-2.3 1.864-4.163 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 23.753h-12.243v12.244h12.243V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.876 23.753h-12.243v12.244h12.243V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 23.753h-12.243v12.244h12.243V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.383 23.753h12.243v8.08c0 2.3-1.863 4.164-4.162 4.164h-8.081V23.753ZM190.376 23.753h-12.243v12.244h12.243V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.267 23.753h-12.244v12.244h12.244V23.753ZM222.289 35.752v.244h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.895 35.997h-12.244v-8.081c0-2.3 1.864-4.163 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.767 23.753h-12.244v12.244h12.244V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 23.753h-12.244v12.244h12.244V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.525 23.753h-12.244v12.244h12.244V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 23.753h-12.244v12.244H285.4V23.753Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.031 35.997V23.753h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM131.001 35.629h-12.243v12.244h12.243V35.629ZM178.504 47.873H166.26v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.376 35.629h-12.243v12.244h12.243V35.629Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.267 35.629h-12.244v12.244h12.244V35.629ZM226.02 47.873h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.648 35.629h12.244v8.08c0 2.3-1.864 4.164-4.163 4.164h-8.081V35.629ZM273.523 35.629v8.08c0 2.3-1.863 4.164-4.162 4.164h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243ZM297.273 35.629v8.08c0 2.3-1.863 4.164-4.162 4.164h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243ZM107.25 59.749H95.006v-8.08c0-2.3 1.864-4.164 4.163-4.164h8.081V59.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 47.505h-12.243V59.75h12.243V47.505Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 47.505h-12.243V59.75h12.243V47.505Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 59.749V47.505h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM178.501 47.505h-12.243V59.75h12.243V47.505Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.376 47.505h-12.243V59.75h12.243V47.505Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.023 47.505h12.244v8.081c0 2.3-1.864 4.163-4.163 4.163h-8.081V47.505ZM249.77 59.749h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918c0-2.299 1.864-4.163 4.163-4.163h8.081V59.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.398 59.749V47.505h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM273.156 51.007v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.51 3.51 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM107.251 59.382H95.008v12.244h12.243V59.382ZM142.879 59.382v12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.508 71.626V59.382h8.081a4.162 4.162 0 0 1 4.162 4.163v8.08h-12.243ZM178.501 59.382h-12.243v12.244h12.243V59.382Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 59.382h12.243v8.08c0 2.3-1.863 4.163-4.162 4.163h-8.081V59.383ZM214.145 71.626h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918c0-2.3 1.864-4.163 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.017 59.382h-12.244v12.244h12.244V59.382Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.648 71.626V59.382h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM261.645 59.382v8.08c0 2.3-1.864 4.163-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.162v-8.081h12.244ZM285.031 71.626v-8.081c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM107.25 71.258v8.08c0 2.3-1.864 4.163-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.162v-8.081h12.244ZM118.758 74.76v5.252a3.49 3.49 0 0 0 3.501 3.49h5.253A3.493 3.493 0 0 0 131.014 80v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.241a3.5 3.5 0 0 0-3.501 3.502ZM154.751 71.258h-12.243V83.5h12.243V71.258ZM162.906 83.257v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 71.258h-12.243V83.5h12.243V71.258ZM186.656 83.257v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.023 83.501v-8.08c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM226.02 71.258v8.08c0 2.3-1.864 4.163-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.162v-8.081h12.244ZM234.164 83.257v.245h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.523 83.501v-8.08c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM257.914 83.257v.245h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.281 83.502v-8.08a4.163 4.163 0 0 1 4.163-4.164h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM297.273 71.258v8.08c0 2.3-1.863 4.163-4.162 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.162v-8.081h12.243ZM142.879 95.378h-12.244v-8.08c0-2.3 1.864-4.164 4.163-4.164h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 83.134h-12.243v12.244h12.243V83.134Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.626 83.134h-12.243v12.244h12.243V83.134Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 83.134h-12.243v12.244h12.243V83.134Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.376 83.134h-12.243v12.244h12.243V83.134Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.023 83.134h12.244v8.081c0 2.3-1.864 4.163-4.163 4.163h-8.081V83.134ZM237.895 95.378h-12.244v-8.08c0-2.3 1.864-4.164 4.163-4.164h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.767 83.134h-12.244v12.244h12.244V83.134Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 83.134h-12.244v12.244h12.244V83.134Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.281 83.134h12.244v8.081c0 2.3-1.864 4.163-4.163 4.163h-8.081V83.134ZM24.117 107.254h-8.08a4.162 4.162 0 0 1-4.163-4.162v-3.918c0-2.3 1.863-4.163 4.162-4.163h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.994 95.01H23.75v12.244h12.244V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.869 95.01H35.625v12.244h12.244V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.752 95.01H47.508v12.244H59.75V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.626 95.01H59.383v12.244h12.243V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.501 95.01H71.258v12.244H83.5V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.133 107.254V95.011h8.08c2.3 0 4.163 1.864 4.163 4.163v8.08H83.133ZM142.879 95.01v12.244h-8.081a4.162 4.162 0 0 1-4.163-4.162v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 95.01h-12.243v12.244h12.243V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.626 95.01h-12.243v12.244h12.243V95.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.258 95.01h12.243v8.082a4.161 4.161 0 0 1-4.162 4.162h-8.081V95.011ZM198.531 107.009v.245h3.735v-3.734h-.245a3.487 3.487 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.898 107.254v-8.08c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM237.892 95.01h-12.244v12.244h12.244V95.011ZM317.305 107.009v.245h3.734v-3.734h-.245a3.487 3.487 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.898 107.254h-12.243v-8.08c0-2.3 1.864-4.163 4.163-4.163h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.539 107.254V95.011h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM380.039 107.254v-8.08c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM35.992 106.887v12.244h-8.08a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.869 106.887H35.625v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.752 106.887H47.508v12.244H59.75v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.383 106.887h12.243v8.081a4.163 4.163 0 0 1-4.162 4.163h-8.081v-12.244ZM166.626 106.887h-12.243v12.244h12.243v-12.244ZM202.27 119.131h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.142 106.887h-12.244v12.244h12.244v-12.244ZM237.895 106.887v12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.523 119.131v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM273.156 110.389v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM305.43 118.886v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.023 119.131H308.78v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.656 106.887H332.9v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.244ZM356.656 119.131h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.289 119.131v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM392.281 106.887v8.081a4.163 4.163 0 0 1-4.163 4.163H384.2a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM0 131.007v-8.08c0-2.3 1.864-4.163 4.163-4.163H8.08c2.299 0 4.163 1.863 4.163 4.163v8.08H0ZM83.5 131.007h-8.081a4.162 4.162 0 0 1-4.163-4.163v-3.917c0-2.3 1.864-4.163 4.163-4.163h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.376 118.764H83.133v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 118.764H95.008v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 118.764h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 118.764h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 131.007v-12.243h8.081a4.162 4.162 0 0 1 4.162 4.163v8.08h-12.243ZM166.626 118.764h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 118.764h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 131.007v-12.243h8.081a4.162 4.162 0 0 1 4.162 4.163v8.08h-12.243ZM214.142 118.764h-12.244v12.243h12.244v-12.243ZM249.77 118.764v8.08c0 2.3-1.864 4.163-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM261.281 122.265v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM309.148 131.007h-12.243v-8.08c0-2.3 1.864-4.163 4.163-4.163h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.781 118.764h12.244v8.08c0 2.3-1.864 4.163-4.163 4.163h-8.081v-12.243ZM332.539 131.007v-8.08c0-2.3 1.864-4.163 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM352.93 130.762v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.533 118.764h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 131.007v-12.243h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM12.244 130.64H0v12.243h12.244V130.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.119 130.64H11.875v12.243h12.244V130.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 142.883V130.64h8.08c2.3 0 4.164 1.863 4.164 4.162v8.081H23.75ZM47.508 134.141v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.511 3.511 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM95.375 130.64v12.243h-8.081a4.162 4.162 0 0 1-4.163-4.163v-8.08h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 130.64H95.008v12.243h12.243V130.64ZM131.001 130.64h-12.243v12.243h12.243V130.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.876 130.64h-12.243v12.243h12.243V130.64ZM166.629 130.64v8.08c0 2.3-1.864 4.163-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM190.379 130.64v8.08c0 2.3-1.864 4.163-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM214.145 130.64v12.243h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.773 142.883V130.64h8.081a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM249.398 134.141v5.253a3.491 3.491 0 0 0 3.502 3.489h5.253a3.493 3.493 0 0 0 3.501-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.501 3.501 0 0 0-3.502 3.501ZM309.148 130.64v8.08c0 2.3-1.863 4.163-4.162 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.243ZM329.18 142.638v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 130.64h-12.244v12.243h12.244V130.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 130.64h-12.244v12.243h12.244V130.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.289 130.64h12.244v8.08c0 2.3-1.864 4.163-4.163 4.163h-8.081V130.64ZM12.242 142.516v8.081a4.163 4.163 0 0 1-4.163 4.163H4.161A4.163 4.163 0 0 1 0 150.597v-8.081h12.243ZM35.625 146.018v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM71.258 146.018v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24A3.511 3.511 0 0 0 80 142.516h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM107.251 142.516H95.008v12.244h12.243v-12.244ZM131.001 142.516h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 142.516h12.243v8.081a4.162 4.162 0 0 1-4.162 4.163h-8.081v-12.244ZM261.281 146.018v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM285.031 146.018v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM332.898 154.76h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 142.516h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 142.516h-12.244v12.244h12.244v-12.244ZM380.406 154.76h-12.244v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.039 154.76v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM23.75 157.894v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.511 3.511 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM59.75 166.636h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.162 4.162 0 0 1 4.163-4.162h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.383 166.636v-12.243h8.08c2.3 0 4.163 1.863 4.163 4.162v8.081H59.383ZM107.25 154.393v8.08a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM131.001 154.393h-12.243v12.243h12.243v-12.243ZM273.156 157.894v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM293.555 166.391v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.148 166.636h-12.243v-8.081a4.162 4.162 0 0 1 4.163-4.162h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.781 166.636v-12.243h8.081a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM356.656 154.393v8.08a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM364.805 166.391v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.408 154.393h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.039 154.393h12.244v8.08a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.243ZM11.875 169.771v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM32.258 178.268v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 178.513v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918c2.299 0 4.163 1.864 4.163 4.163v8.081H35.625ZM71.625 166.269v12.243h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.501 166.269H71.258v12.243H83.5v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.133 178.512v-12.243h8.08c2.3 0 4.163 1.863 4.163 4.162v8.081H83.133ZM131.004 166.269v8.08a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM261.281 169.771v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM297.273 178.512h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.162 4.162 0 0 1 4.163-4.162h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 166.269h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.025 166.269h-12.244v12.244h12.244v-12.244ZM332.539 178.512v-8.081a4.162 4.162 0 0 1 4.163-4.162h3.918a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM368.531 178.512h-12.244v-8.081a4.162 4.162 0 0 1 4.163-4.162h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 166.269h12.244v8.08a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.243ZM0 181.647v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.494 3.494 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.24A3.5 3.5 0 0 0 0 181.647ZM35.992 190.389h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.162-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 178.145h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.244ZM103.523 190.144v.245h3.735v-3.735h-.245a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.883 190.389v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM130.633 181.647v5.252a3.49 3.49 0 0 0 3.501 3.49h5.253a3.494 3.494 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.241a3.5 3.5 0 0 0-3.501 3.502ZM249.398 181.647v5.252a3.491 3.491 0 0 0 3.502 3.49h5.253a3.494 3.494 0 0 0 3.501-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.501 3.501 0 0 0-3.502 3.502ZM269.789 190.144v.245h3.734v-3.735h-.244a3.489 3.489 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.156 190.389v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM309.15 178.145h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.781 178.145h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.244ZM329.18 190.144v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 178.145h-12.244v12.244h12.244v-12.244ZM368.531 178.145v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM83.5 202.265h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.376 190.021H83.133v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 190.021H95.008v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 190.021h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.758 202.265v-12.244h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM273.523 202.265h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 190.021h-12.244v12.244H285.4v-12.244ZM309.148 190.021v8.081a4.162 4.162 0 0 1-4.162 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243ZM317.305 202.02v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.898 202.265h-12.243v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 190.021h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.414 202.265v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM380.039 202.265v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM0 214.142v-8.081a4.163 4.163 0 0 1 4.163-4.163H8.08c2.299 0 4.163 1.864 4.163 4.163v8.081H0ZM32.258 213.897v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.867 214.141H35.624v-8.081a4.163 4.163 0 0 1 4.162-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.508 214.141v-12.244h8.08c2.3 0 4.163 1.864 4.163 4.163v8.081H47.508ZM107.25 201.897v12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.883 201.897h12.243v8.081a4.162 4.162 0 0 1-4.162 4.163h-8.081v-12.244ZM249.398 205.399v5.253a3.491 3.491 0 0 0 3.502 3.489h5.253a3.493 3.493 0 0 0 3.501-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.502 3.502 0 0 0-3.502 3.502ZM285.398 201.897v8.081a4.162 4.162 0 0 1-4.162 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243ZM305.43 213.897v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.023 214.141H308.78v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.9 201.898h-12.244v12.244H332.9v-12.244ZM356.656 201.897v12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.289 214.141v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM392.281 201.897v8.081a4.163 4.163 0 0 1-4.163 4.163H384.2a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM12.242 213.774v12.244h-8.08a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.119 213.774H11.875v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.994 213.774H23.75v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 213.774h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.244ZM71.625 226.018h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.501 213.774H71.258v12.244H83.5v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.133 226.018v-12.244h8.08c2.3 0 4.163 1.864 4.163 4.163v8.081H83.133ZM118.758 226.018v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM257.914 225.773v.245h3.734v-3.735h-.244a3.489 3.489 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.281 226.018v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM297.273 226.018h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 213.774h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.025 213.774h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.9 213.774h-12.244v12.244H332.9v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.539 226.018v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM352.93 225.773v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.533 213.774h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 226.018v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM24.117 225.65v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM47.508 237.894v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918c2.299 0 4.163 1.864 4.163 4.163v8.081H47.508ZM95.008 237.894v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081H95.008ZM131.001 225.65h-12.243v12.244h12.243V225.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 237.894V225.65h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM261.645 237.894h-12.244v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.525 225.65h-12.244v12.244h12.244V225.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.156 237.894V225.65h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM293.555 237.649v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 225.65h-12.244v12.244h12.244V225.65ZM332.9 225.65h-12.244v12.244H332.9V225.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 225.65h-12.244v12.244h12.244V225.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 225.65h-12.244v12.244h12.244V225.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.533 225.65h-12.244v12.244h12.244V225.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 225.65h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081V225.65ZM23.75 241.029v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.494 3.494 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM59.75 237.527v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081H59.75ZM71.258 241.029v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.494 3.494 0 0 0 3.502-3.502v-5.24A3.511 3.511 0 0 0 80 237.527h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM91.648 249.526v.244h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 237.527H95.008v12.244h12.243v-12.244ZM131.004 237.527v12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 237.527h12.243v8.081a4.162 4.162 0 0 1-4.162 4.163h-8.081v-12.244ZM246.039 249.526v.244h3.734v-3.734h-.244a3.489 3.489 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 237.527h-12.244v12.244h12.244v-12.244ZM285.4 237.527h-12.244v12.244H285.4v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.275 237.527h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.906 237.527h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.244ZM332.898 237.527v12.244h-8.08a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 237.527h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 237.527h-12.244v12.244h12.244v-12.244ZM0 261.647v-8.081a4.163 4.163 0 0 1 4.163-4.163H8.08c2.299 0 4.163 1.864 4.163 4.163v8.081H0ZM35.625 252.905v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.24a3.502 3.502 0 0 0-3.502 3.502ZM59.383 252.905v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.502 3.502 0 0 0-3.502 3.502ZM79.773 261.402v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.375 261.647H83.13v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 249.403H95.008v12.244h12.243v-12.244ZM142.508 261.647v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM166.258 261.647v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM214.145 261.647h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.773 261.647v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM249.77 261.647h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 249.403h-12.244v12.244h12.244v-12.244ZM285.398 249.403v8.081a4.162 4.162 0 0 1-4.162 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243ZM305.43 261.402v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.781 261.647v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM356.658 249.403h-12.244v12.244h12.244v-12.244ZM380.039 252.905v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.501 3.501 0 0 0-3.502 3.502ZM12.244 261.279H0v12.244h12.244v-12.244ZM83.5 273.523h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.376 261.279H83.133v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.008 261.279h12.243v8.081a4.162 4.162 0 0 1-4.162 4.163h-8.081v-12.244ZM139.156 273.278v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 261.279h-12.243v12.244h12.243v-12.244ZM162.906 273.278v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 261.279h-12.243v12.244h12.243v-12.244ZM190.023 264.781v5.253a3.491 3.491 0 0 0 3.502 3.489h5.253a3.493 3.493 0 0 0 3.501-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.501 3.501 0 0 0-3.502 3.502ZM222.289 273.278v.245h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.648 273.523v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM246.039 273.278v.245h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 261.279h-12.244v12.244h12.244v-12.244ZM293.555 273.278v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.148 273.523h-12.243v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.025 261.279h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.9 261.279h-12.244v12.244H332.9v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 261.279h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 261.279h-12.244v12.244h12.244v-12.244ZM364.805 273.278v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 273.523v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM12.244 273.156H0v12.243h12.244v-12.243ZM35.625 276.657v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.511 3.511 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM95.375 273.156v8.081a4.162 4.162 0 0 1-4.163 4.162h-3.918a4.162 4.162 0 0 1-4.163-4.162v-8.081h12.244ZM142.879 285.399h-8.081a4.162 4.162 0 0 1-4.163-4.162v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 273.156h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.626 273.156h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 273.156h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 285.399v-12.243h8.081a4.162 4.162 0 0 1 4.162 4.163v8.08h-12.243ZM210.414 285.154v.245h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.02 285.399h-12.244v-8.08a4.163 4.163 0 0 1 4.163-4.163h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.892 273.156h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.767 273.156h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 273.156h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.281 285.399v-12.243h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM297.273 285.399H285.03v-8.08a4.163 4.163 0 0 1 4.163-4.163h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 273.156h-12.244v12.243h12.244v-12.243ZM332.9 273.156h-12.244v12.243H332.9v-12.243ZM356.656 273.156v12.243h-8.081a4.162 4.162 0 0 1-4.163-4.162v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.533 273.156h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.408 273.156h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.039 285.399v-12.243h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM12.242 285.032v8.081a4.163 4.163 0 0 1-4.163 4.163H4.161A4.163 4.163 0 0 1 0 293.113v-8.081h12.243ZM23.75 288.534v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.512 3.512 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM71.258 288.534v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24A3.511 3.511 0 0 0 80 285.032h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM95.008 297.276v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081H95.008ZM115.398 297.031v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.758 297.276v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM166.629 285.032v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM214.145 297.276h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.017 285.032h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.892 285.032h-12.244v12.244h12.244v-12.244ZM273.525 285.032h-12.244v12.244h12.244v-12.244ZM297.275 285.032h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 285.032h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.025 285.032h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.9 285.032h-12.244v12.244H332.9v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.539 297.276v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM380.406 285.032v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM107.251 296.908H95.008v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 296.908h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 296.908h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 309.152v-12.244h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM166.258 309.152v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM190.023 300.41v5.252a3.491 3.491 0 0 0 3.502 3.49h5.253a3.493 3.493 0 0 0 3.501-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.501 3.501 0 0 0-3.502 3.502ZM237.895 296.908v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM273.525 296.909h-12.244v12.243h12.244v-12.243ZM281.664 308.907v.245h3.734v-3.734h-.244a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.275 296.909h-12.244v12.243h12.244v-12.243ZM344.783 296.908h-12.244v12.244h12.244v-12.244ZM356.289 309.152v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM380.039 300.41v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.493 3.493 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM107.251 308.785H95.008v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 308.785h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 308.785h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.876 308.785h-12.243v12.243h12.243v-12.243ZM178.501 308.785h-12.243v12.243h12.243v-12.243ZM213.773 312.286v5.253a3.491 3.491 0 0 0 3.502 3.489h5.253a3.493 3.493 0 0 0 3.501-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.501 3.501 0 0 0-3.502 3.501ZM273.523 308.785v12.243h-8.08a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 308.785h-12.244v12.243H285.4v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.275 308.785h-12.244v12.243h12.244v-12.243ZM308.781 312.286v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM344.783 308.785h-12.244v12.243h12.244v-12.243ZM352.93 320.783v.245h3.734v-3.734h-.245a3.488 3.488 0 0 1-3.489 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.533 308.785h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 321.028v-12.243h8.081a4.163 4.163 0 0 1 4.163 4.163v8.08h-12.244ZM107.251 320.661H95.008v12.244h12.243v-12.244ZM131.004 320.661v12.244h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.876 320.661h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.508 332.905v-12.244h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM162.906 332.66v.245h3.735v-3.735h-.245a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 320.661h-12.243v12.244h12.243v-12.244ZM198.531 332.66v.245h3.735v-3.735h-.245a3.488 3.488 0 0 1-3.49 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.898 332.905v-8.081a4.163 4.163 0 0 1 4.163-4.163h3.918a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM285.398 320.661v12.244h-8.08a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.275 320.661h-12.244v12.244h12.244v-12.244ZM329.18 332.66v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 320.661h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 320.661h-12.244v12.244h12.244v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.289 320.661h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.244ZM107.251 332.538H95.008v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.883 344.781v-12.243h8.081a4.161 4.161 0 0 1 4.162 4.162v8.081h-12.243ZM154.751 332.538h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.626 332.538h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 332.538h-12.243v12.243h12.243v-12.243ZM202.27 344.781h-8.081a4.163 4.163 0 0 1-4.163-4.163V336.7a4.162 4.162 0 0 1 4.163-4.162h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.142 332.538h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.773 344.781v-12.243h8.081a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM249.77 344.781h-8.081a4.163 4.163 0 0 1-4.163-4.163V336.7a4.162 4.162 0 0 1 4.163-4.162h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 332.538h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.281 344.781v-12.243h8.081a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM297.275 332.538h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 332.538h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.025 332.538h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.9 332.538h-12.244v12.243H332.9v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.783 332.538h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 332.538h-12.244v12.243h12.244v-12.243ZM368.164 336.039v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM107.251 344.414H95.008v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 344.414h-12.243v12.243h12.243v-12.243ZM142.879 356.658h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.508 344.414h12.243v8.08a4.162 4.162 0 0 1-4.162 4.163h-8.081v-12.243ZM178.501 344.414h-12.243v12.243h12.243v-12.243ZM261.642 344.414h-12.244v12.243h12.244v-12.243ZM285.398 356.658h-12.243v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.275 344.414h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.906 344.414h12.244v8.08a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.243ZM344.781 344.414v12.244H336.7a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 344.414h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.289 356.657v-12.243h8.081a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM380.039 347.915v5.253a3.49 3.49 0 0 0 3.502 3.489h5.252a3.493 3.493 0 0 0 3.502-3.501v-5.241a3.51 3.51 0 0 0-3.514-3.501h-5.24a3.5 3.5 0 0 0-3.502 3.501ZM107.251 356.29H95.008v12.244h12.243V356.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 356.29h-12.243v12.244h12.243V356.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.758 368.534V356.29h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM178.501 356.29h-12.243v12.244h12.243V356.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 368.534V356.29h8.081a4.162 4.162 0 0 1 4.162 4.163v8.081h-12.243ZM214.145 368.534h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.773 368.534V356.29h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM249.77 368.534h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.642 356.29h-12.244v12.244h12.244V356.29ZM285.398 356.29v12.244h-8.08a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.031 356.29h12.244v8.081a4.163 4.163 0 0 1-4.163 4.163h-8.081V356.29ZM305.43 368.289v.245h3.734v-3.735h-.245a3.488 3.488 0 0 1-3.489 3.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.023 368.534H308.78v-8.081a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.656 368.534V356.29h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM107.25 368.167v12.243h-8.081a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.126 368.167h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 368.167h-12.243v12.243h12.243v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 380.41v-12.243h8.081a4.161 4.161 0 0 1 4.162 4.162v8.081h-12.243ZM162.906 380.165v.245h3.735v-3.734h-.245a3.488 3.488 0 0 1-3.49 3.489Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 368.167h-12.243v12.243h12.243v-12.243ZM261.645 368.167v8.08a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.08h12.244ZM309.148 380.41h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.162 4.162 0 0 1 4.163-4.162h8.08v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.781 368.167h12.244v8.08a4.163 4.163 0 0 1-4.163 4.163h-8.081v-12.243ZM344.781 380.41H336.7a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.162 4.162 0 0 1 4.163-4.162h8.081v12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.658 368.167h-12.244v12.243h12.244v-12.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.289 380.41v-12.243h8.081a4.162 4.162 0 0 1 4.163 4.162v8.081h-12.244ZM142.879 380.043v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM166.629 392.287h-8.081a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.081v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.501 380.043h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.376 380.043h-12.243v12.244h12.243v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.023 392.287v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM237.523 383.545v5.252a3.491 3.491 0 0 0 3.502 3.49h5.253a3.494 3.494 0 0 0 3.501-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.501 3.501 0 0 0-3.502 3.502ZM273.523 392.287h-8.08a4.163 4.163 0 0 1-4.163-4.163v-3.918a4.163 4.163 0 0 1 4.163-4.163h8.08v12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 380.043h-12.244v12.244H285.4v-12.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.031 392.287v-12.244h8.081a4.163 4.163 0 0 1 4.163 4.163v8.081h-12.244ZM320.656 383.545v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.494 3.494 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502ZM356.656 380.043v8.081a4.163 4.163 0 0 1-4.163 4.163h-3.918a4.163 4.163 0 0 1-4.163-4.163v-8.081h12.244ZM368.164 383.545v5.252a3.49 3.49 0 0 0 3.502 3.49h5.252a3.494 3.494 0 0 0 3.502-3.502v-5.24a3.511 3.511 0 0 0-3.514-3.502h-5.24a3.5 3.5 0 0 0-3.502 3.502Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.462 55.994V29.71c0-11.666-1.587-14.513-2.27-15.197-.684-.682-3.53-2.27-15.198-2.27H29.712c-11.668 0-14.515 1.588-15.197 2.27-.683.684-2.272 3.53-2.272 15.197v26.284c0 11.668 1.589 14.514 2.272 15.198.682.682 3.529 2.27 15.197 2.27h26.282c11.668 0 14.514-1.588 15.198-2.27.683-.684 2.27-3.53 2.27-15.198ZM55.994 0c23.999 0 29.712 5.713 29.712 29.71v26.284c0 23.999-5.713 29.712-29.712 29.712H29.712C5.713 85.706 0 79.993 0 55.993V29.71C0 5.713 5.713 0 29.712 0h26.282Zm-7.51 24.487c10.286 0 12.734 2.45 12.734 12.733v11.264c0 10.285-2.448 12.734-12.734 12.734H37.221c-10.284 0-12.734-2.45-12.734-12.734V37.22c0-10.283 2.45-12.733 12.734-12.733h11.263ZM379.068 55.994V29.71c0-11.666-1.587-14.513-2.27-15.197-.684-.682-3.531-2.27-15.199-2.27h-26.282c-11.668 0-14.514 1.588-15.197 2.27-.683.684-2.271 3.53-2.271 15.197v26.284c0 11.668 1.588 14.514 2.271 15.198.683.682 3.529 2.27 15.197 2.27h26.282c11.668 0 14.515-1.588 15.199-2.27.683-.684 2.27-3.53 2.27-15.198ZM361.599 0c23.999 0 29.712 5.713 29.712 29.71v26.284c0 23.999-5.713 29.712-29.712 29.712h-26.282c-23.998 0-29.712-5.713-29.712-29.712V29.71c0-23.997 5.714-29.71 29.712-29.71h26.282Zm-7.509 24.487c10.285 0 12.734 2.45 12.734 12.733v11.264c0 10.285-2.449 12.734-12.734 12.734h-11.263c-10.284 0-12.734-2.45-12.734-12.734V37.22c0-10.283 2.45-12.733 12.734-12.733h11.263ZM73.462 361.595v-26.283c0-11.667-1.587-14.513-2.27-15.197-.684-.683-3.53-2.27-15.198-2.27H29.712c-11.668 0-14.515 1.587-15.197 2.27-.683.684-2.272 3.53-2.272 15.197v26.283c0 11.668 1.589 14.515 2.272 15.199.682.681 3.529 2.27 15.197 2.27h26.282c11.668 0 14.514-1.589 15.198-2.27.683-.684 2.27-3.531 2.27-15.199Zm-17.468-55.993c23.999 0 29.712 5.713 29.712 29.71v26.283c0 23.999-5.713 29.712-29.712 29.712H29.712C5.713 391.307 0 385.594 0 361.595v-26.283c0-23.997 5.713-29.71 29.712-29.71h26.282Zm-7.51 24.487c10.286 0 12.734 2.45 12.734 12.732v11.265c0 10.284-2.448 12.734-12.734 12.734H37.221c-10.284 0-12.734-2.45-12.734-12.734v-11.265c0-10.282 2.45-12.732 12.734-12.732h11.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qr_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.849 193.768c.035-.8.053-1.6.053-2.402 0-23.427-17.021-42.419-38.018-42.419-20.996 0-38.017 18.992-38.017 42.419 0 .802.022 1.602.066 2.402h75.916Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.884 210.344c20.997 0 38.018-7.883 38.018-17.608 0-9.724-17.021-17.608-38.018-17.608-20.996 0-38.017 7.884-38.017 17.608 0 9.725 17.021 17.608 38.017 17.608Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.493 207.549c-.002-.457-.004-.906-.004-1.347 0-11.972-11.02-21.677-24.613-21.677-13.594 0-24.613 9.705-24.613 21.677 0 .564-.003 1.143-.006 1.733-.043 7.996-.097 18.122 7.334 23.934v-24.32h3.792v-.324l.001-1.023c0-4.544 4.671-10.555 13.492-10.555 8.821 0 13.492 6.011 13.492 10.555v1.347h11.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.879 206.467v23.178M196.469 209.871v28.074M177.766 206.941v22.619",
    stroke: "#fff",
    strokeWidth: 10.565,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qr_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h400v400H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qr_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(148.945 148.947)",
    d: "M0 0h95.79v95.79H0z"
  })))));
};
export default SvgQr;